import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'pcln-design-system'
import { Star, StarHalf } from 'pcln-icons'
import styled from 'styled-components'

const StarsWrapper = styled(Box)`
  line-height: 0;
`

const StarIcon = styled(Star)`
  filter: ${(props) => props.addDropShadow && 'drop-shadow(1px 2px 1px rgba(0,0,0,.5))'};
`

const StarHalfIcon = styled(StarHalf)`
  filter: ${(props) => props.addDropShadow && 'drop-shadow(1px 2px 1px rgba(0,0,0,.5))'};
`

const _setStarStyle = (stars) => {
  const roundedStarsTimes = Math.round(stars * 10)

  // doesn't round to a full or half
  if (roundedStarsTimes % 5 !== 0) {
    return []
  }

  const hasHalf = roundedStarsTimes % 10 !== 0
  const realStarsWithoutDecimal = Math.floor(roundedStarsTimes / 10)
  const starsStyle = Array(realStarsWithoutDecimal)
  if (!hasHalf) {
    starsStyle.fill('full')
    return starsStyle
  } else {
    starsStyle.fill('full', 0)
    starsStyle.push('half')
    return starsStyle
  }
}

const _renderStars = (stars, size, color, addDropShadow) =>
  stars.map((star, index) => {
    switch (star) {
      case 'full':
        return (
          <StarIcon
            addDropShadow={addDropShadow}
            key={index}
            size={size}
            color={color}
            data-testid='fullStar'
          />
        )

      case 'half':
        return (
          <StarHalfIcon
            addDropShadow={addDropShadow}
            key={index}
            color={color}
            size={size}
            data-testid='halfStar'
          />
        )
    }
  })

const Stars = ({ stars, size, color, addDropShadow }) => {
  const starsStyle = _setStarStyle(stars)
  return <StarsWrapper>{_renderStars(starsStyle, size, color, addDropShadow)}</StarsWrapper>
}

Stars.propTypes = {
  stars: PropTypes.oneOf([0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]).isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  addDropShadow: PropTypes.bool,
}
Stars.defaultProps = {
  size: 24,
  color: 'primary.base',
}

export default Stars
